<template>
    <div>
        <h4 class="mb-3 text-uppercase">EXTRA E-MAIL ADRES</h4>
        <div v-html="$t('account.extraEmailSection.description')"></div>

        <MDBRow v-for="(email, index) in emails" :key="index">
            <MDBCol cols="12" md="6">
                <label :for="'email' + index" class="label px-3 text-uppercase">
                    {{ $t("account.profile.email") }}
                </label>
                <div class="d-flex justify-content-space-between align-items-center">
                    <Field type="text" class="form-control" :placeholder="$t('account.profile.email')"
                        :aria-label="$t('account.profile.email')" aria-describedby="basic-addon1"
                        v-model="emails[index].email" :id="'email' + index" :rules="{ required: true, email: true }"
                        :name="'email' + index" :label="$t('account.profile.email')" />
                </div>
                <div>
                    <ErrorMessage :name="'email' + index" class="text-danger text-small text-end m-0 pt-1" />
                </div>
            </MDBCol>
            <MDBCol cols="12" md="6">
                <div class="input-group mb-1">
                    <div>
                        <label for="email_type" class="label text-uppercase my-1">
                            Email type
                        </label>
                    </div>

                    <div class="d-flex justify-content-space-between align-items-center w-100">
                        <Field :name="'email_type' + index" as="select" class="form-select w-100"
                            aria-label=".form-select-lg example" v-model="emails[index].email_type"
                            :rules="{ required: true }" label="Email type">
                            <option :value="4">
                                {{ $t('account.extraEmailSection.optionOne') }}
                            </option>
                            <option :value="1">
                                {{ $t('account.extraEmailSection.optionTwo') }}
                            </option>
                        </Field>

                        <img src="@/assets/img/icons/trash.svg" alt="trash" class="icon-container ms-3"
                            @click="deleteEmail(index)" v-if="emails.length > 1 && index != 0" />
                    </div>
                    <div class="w-100">
                        <ErrorMessage :name="'email_type' + index" class="text-danger text-small text-end m-0 pt-1" />
                    </div>
                </div>
            </MDBCol>
        </MDBRow>
        <div @click="addNewEmail()" :disabled="emails.length == 5"
            :class="`${emails.length == 5 ? '' : 'cursor--pointer'}`"><img
                :src="require('@/assets/img/plus_btn_small.svg')" alt="logo" />
            {{ $t("account.buttons.addNewEmail") }} (max. 5)
        </div>
    </div>
</template>


<script setup>
import { MDBRow, MDBCol } from "mdb-vue-ui-kit";
import { useStore } from "vuex";
import { ref, computed, defineExpose, watch } from "vue";
import { Field, ErrorMessage, defineRule } from "vee-validate";
import { required, email } from "@vee-validate/rules";

// Validation rules
defineRule('required', required);
defineRule('email', email);

const store = useStore();
const emails = ref([{
    email: '',
    email_type: 1
}]);
const me = computed(() => store.getters.getMe);

watch(
    me,
    (newVal) => {
        if (!newVal?.tenant_emails?.length) {
            return;
        }
        emails.value = newVal.tenant_emails.map((value) => ({
            email: value.email,
            email_type: value.email_type,
        }));
    },
    { immediate: true },
);

const addNewEmail = () => {
    if (emails.value.length < 5) {
        emails.value.push({
            email: '',
            email_type: 1
        })
    }
}

const deleteEmail = (index) => {
    emails.value.splice(index, 1);
}

defineExpose({
    emails
});
</script>